import Vue from 'vue'
import Router from 'vue-router'

import LandingHome from '../pages/LandingHome'
import SignInPage from '../pages/SignInPage'
import DemoPage from '../pages/DemoPage'

import { firebase } from '@/common/firebaseConfig.js'
Vue.use(Router)

const router =  new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name : 'Home',
      component : LandingHome,
      meta : {
        redirectIfLoggedIn: false, // Set this back to true for launch
        requiresAuth: false,
        title : "Landing Home Page",
        metaTags: [
          {
            name: 'Landing Home Page',
            content: 'Landing Home Page'
          }
        ]
      }
    },
    {
      path: '/demo',
      name : 'Demo',
      component : DemoPage,
      meta : {
        redirectIfLoggedIn: false, // Set this back to true for launch
        requiresAuth: false,
        title : "Demo Page",
        metaTags: [
          {
            name: 'Demo Page',
            content: 'Demo Page'
          }
        ]
      }
    },
    {
      path: '/signin',
      name : 'Sign In',
      component : SignInPage,
      meta : {
        redirectIfLoggedIn: false,
        requiresAuth: false,
        title : "SignIn Page",
        metaTags: [
          {
            name: 'SignIn Page',
            content: 'SignIn Page'
          }
        ]
      }
    },

  ]
})



router.beforeEach( (to, from, next) => {
  // console.log("Router beforeEach called", to);
  let currentUser = firebase.auth().currentUser
  let redirectIfLoggedIn = to.matched.some(record => record.meta.redirectIfLoggedIn)
  if(currentUser) {
    /* mixpanel.identify(currentUser.uid);
    mixpanel.track("pageview", {
    "path": to.path,
    });
    */
  }
  if ( redirectIfLoggedIn && currentUser) next('home')
  let requiresAuth = to.matched.some( record => record.meta.requiresAuth )
  if ( requiresAuth && !currentUser ) {
    // console.log("requiresAuth found, redirecting");
    // console.log(to.path)
    next('/loginRequired?continue='+to.path)
  }
  // else if ( !requiresAuth && !currentUser) next('Hello')
  else next()
})


import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
  id: 'UA-138575033-1',
  router,
  debug: {
    enabled: false//true
  }
})


export default router
